import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAngry = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 46,
	height: 46,
	viewBox: "0 0 46 46",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.6 10.6288 0.6 23C0.6 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint0_radial_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M23 45.4C35.3712 45.4 45.4 35.3712 45.4 23C45.4 10.6288 35.3712 0.599998 23 0.599998C10.6288 0.599998 0.6 10.6288 0.6 23C0.6 35.3712 10.6288 45.4 23 45.4Z",
			fill: "url(#paint1_radial_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.5727 32.1057C22.5727 32.1057 27.2194 32.0849 28.8135 35.7835C28.9176 36.0127 28.9802 36.2628 29.001 36.5232C29.0427 37.0337 28.6884 37.5651 27.7924 37.2213C26.3755 36.6691 23.948 36.3774 22.5727 36.3774C21.2079 36.3774 18.7699 36.6587 17.353 37.2213C16.4674 37.5651 16.1132 37.0337 16.1444 36.5232C16.1653 36.2628 16.2278 36.0127 16.332 35.7835C17.926 32.0953 22.5727 32.1057 22.5727 32.1057Z",
			fill: "url(#paint2_radial_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6862 28.678C16.8773 28.678 17.8429 27.218 17.8429 25.4169C17.8429 23.6159 16.8773 22.1559 15.6862 22.1559C14.4951 22.1559 13.5296 23.6159 13.5296 25.4169C13.5296 27.218 14.4951 28.678 15.6862 28.678Z",
			fill: "url(#paint3_radial_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.8319 24.2501C16.0925 24.2501 17.1448 25.542 17.4469 27.2923C17.697 26.7609 17.8428 26.115 17.8428 25.4169C17.8428 23.6145 16.8739 22.1559 15.6862 22.1559C14.6547 22.1559 13.79 23.2499 13.5816 24.7189C13.9567 24.4168 14.3839 24.2501 14.8319 24.2501Z",
			fill: "url(#paint4_linear_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3835 17.478C11.4561 17.478 9.79954 19.6972 11.9562 20.041C14.1128 20.3848 18.0407 22.2393 19.6972 23.5208C19.8222 23.6667 20.3119 23.625 20.2807 23.2395C20.2702 21.7705 15.7277 17.478 13.3835 17.478Z",
			fill: "url(#paint5_linear_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.573 33.3247C22.573 33.3247 26.3549 33.3143 28.9387 36.2211C28.9075 36.0752 28.8658 35.9294 28.8033 35.7939C27.2092 32.0953 22.5625 32.1162 22.5625 32.1162C22.5625 32.1162 17.9158 32.0953 16.3218 35.7939C16.2593 35.9294 16.2176 36.0752 16.1863 36.2211C18.7806 33.3143 22.573 33.3247 22.573 33.3247Z",
			fill: "url(#paint6_linear_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.3139 28.678C31.505 28.678 32.4706 27.218 32.4706 25.4169C32.4706 23.6159 31.505 22.1559 30.3139 22.1559C29.1229 22.1559 28.1573 23.6159 28.1573 25.4169C28.1573 27.218 29.1229 28.678 30.3139 28.678Z",
			fill: "url(#paint7_radial_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.1683 24.2501C29.9076 24.2501 28.8553 25.542 28.5532 27.2923C28.3031 26.7609 28.1573 26.115 28.1573 25.4169C28.1573 23.6145 29.1262 22.1559 30.3139 22.1559C31.3454 22.1559 32.2101 23.2499 32.4185 24.7189C32.0434 24.4168 31.6163 24.2501 31.1683 24.2501Z",
			fill: "url(#paint8_linear_5_2646)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.6164 17.478C34.5439 17.478 36.2004 19.6972 34.0438 20.041C31.8871 20.3848 27.9593 22.2393 26.3027 23.5208C26.1777 23.6667 25.688 23.625 25.7193 23.2395C25.7297 21.7705 30.2722 17.478 32.6164 17.478Z",
			fill: "url(#paint9_linear_5_2646)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint0_radial_5_2646",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(27.0227)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFDF30" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFB82E"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint1_radial_5_2646",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(18.5928 13.922) scale(21.26)",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FFE95F" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FFBB47",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint2_radial_5_2646",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(22.5684 34.7203) scale(4.90465 2.61271)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint3_radial_5_2646",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(15.0322 25.4959) rotate(73.854) scale(3.16495 2.04767)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_5_2646",
				x1: 15.7121,
				y1: 23.1485,
				x2: 15.7121,
				y2: 26.0683,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_5_2646",
				x1: 15.6038,
				y1: 25.2286,
				x2: 15.6038,
				y2: 18.4611,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_5_2646",
				x1: 22.5686,
				y1: 30.5086,
				x2: 22.5686,
				y2: 34.035,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("radialGradient", {
				id: "paint7_radial_5_2646",
				cx: 0,
				cy: 0,
				r: 1,
				gradientUnits: "userSpaceOnUse",
				gradientTransform: "translate(31.0087 25.4611) rotate(106.146) scale(3.16495 2.04767)",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#7A4400"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_5_2646",
				x1: 30.288,
				y1: 23.1485,
				x2: 30.288,
				y2: 26.0683,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#512D00"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_5_2646",
				x1: 30.3961,
				y1: 25.2286,
				x2: 30.3961,
				y2: 18.4611,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .00132565,
					stopColor: "#3C2200"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#643800"
				})]
			})
		] })
	]
});
export { SvgAngry as ReactComponent };
